
import axios from 'axios'
import config from '../config'
import { getHeaders, post } from './ApiService'

export const createTask = async (project_id: string, parent?: any) => {

  const url = `${config.apiHost}/programmation-manager/create-task`

  const res = await post(url, { project_id, parent }, `CREATE_TASK`)

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const setTaskWork = async (task_id: string, parent_id: string) => {

  const url = `${config.apiHost}/programmation-manager/set-task-work`

  const res = await post(url, { task_id, parent_id }, `SET_TASK_WORK`)

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateTaskField = async (task_id: string, fieldName: string, value: string) => {

  const url = `${config.apiHost}/programmation-manager/update-task-field`

  const res = await post(url, { task_id, fieldName, value }, `UPDATE_TASK_${fieldName.toUpperCase()}`)

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data.data]
}

export const updateTaskDate = async (task_id: string, fieldName: string, value: string) => {

  const url = `${config.apiHost}/programmation-manager/update-task-date`

  const res = await post(url, { task_id, fieldName, value }, `UPDATE_TASK_${fieldName.toUpperCase()}`)

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateTaskBaseDates = async (task_id: string, baseStart: string, baseEnd: string) => {

  const url = `${config.apiHost}/programmation-manager/update-task-base-dates`

  const res = await post(url, { task_id, baseStart, baseEnd }, `UPDATE_TASK_DATES`)

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateTaskScheduledDates = async (task_id: string, startsAt: string, endsAt: string) => {

  const url = `${config.apiHost}/programmation-manager/update-task-scheduled-dates`

  const res = await post(url, { task_id, startsAt, endsAt }, `UPDATE_TASK_DATES`)

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateTaskActualDates = async (task_id: string, startedAt: string, endedAt: string) => {

  const url = `${config.apiHost}/programmation-manager/update-task-actual-dates`

  const res = await post(url, { task_id, startedAt, endedAt }, `UPDATE_TASK_ACTUAL_DATES`)

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateTaskProgress = async (task_id: string, progress: string) => {
  const url = `${config.apiHost}/programmation-manager/update-task-progress`

  const res = await post(url, { task_id, progress }, 'UPDATE_TASK_PROGRESS')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const confirmOrRejectTask = async (task_id: string, action: 'confirm' | 'reject') => {

  const url = `${config.apiHost}/programmation-manager/confirm-or-reject`

  const res = await post(url, { task_id, action }, 'CONFIRM_OR_REJECT_TASK')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateTaskParentId = async (task_id: string, parent_id: string, project_id: string) => {

  const url = `${config.apiHost}/programmation-manager/update-task-parent-id`

  const res = await post(url, { task_id, parent_id, project_id }, 'UPDATE_TASK_PARENT_ID')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateTaskColorCode = async (task_id: string, color_id: string) => {

  const url = `${config.apiHost}/programmation-manager/update-task-color-code`

  const res = await post(url, { task_id, color_id }, 'UPDATE_TASK_COLOR_CODE')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const createGroup = async (project_id: string, name?: string, parent_id?: string) => {

  const url = `${config.apiHost}/programmation-manager/create-group`

  const res = await post(url, { project_id, name, parent_id }, 'CREATE_GROUP')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateGroupName = async (group_id: string, name: string, project_id: string) => {

  const url = `${config.apiHost}/programmation-manager/update-group-name`

  const res = await post(url, { group_id, name, project_id }, 'UPDATE_GROUP_NAME')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data.data]
}

export const updateGroupParentId = async (group_id: string, parent_id: string, project_id: string) => {

  const url = `${config.apiHost}/programmation-manager/update-group-parent-id`

  const res = await post(url, { group_id, parent_id, project_id }, 'UPDATE_GROUP_PARENT_ID')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data.taskList]
}

export const addComment = async (task_id: string, comment: string) => {

  const url = `${config.apiHost}/programmation-manager/add-comment`

  const res = await post(url, { task_id, comment }, 'ADD_COMMENT')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const addRestrictionComment = async (task_id: string, restriction_id: string, comment: string) => {

  const url = `${config.apiHost}/programmation-manager/add-restriction-comment`

  const res = await post(url, { task_id, restriction_id, comment }, 'ADD_RESTRICTION_COMMENT')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const addColorCode = async (colorCode: any) => {

  const url = `${config.apiHost}/programmation-manager/add-color-code`

  const res = await post(url, colorCode, 'ADD_COLOR_CODE')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data.colorCode]
}

export const updateColorCode = async (colorCode: any) => {

  const url = `${config.apiHost}/programmation-manager/update-color-code`

  const res = await post(url, colorCode, 'UPDATE_COLOR_CODE')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data.colorCode]
}

export const addCost = async (task_id: string, cost: any) => {

  const url = `${config.apiHost}/programmation-manager/add-cost`

  const res = await post(url, { task_id, ...cost }, 'ADD_COST')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateCost = async (cost: any) => {

  const url = `${config.apiHost}/programmation-manager/update-cost`

  const res = await post(url, cost, 'UPDATE_COST')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const deleteCost = async (cost_id: string) => {

  const url = `${config.apiHost}/programmation-manager/delete-cost`

  const res = await post(url, { cost_id }, 'DELETE_COST')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const addRelation = async (relation_type: string, task_from: string, task_to: string) => {

  const url = `${config.apiHost}/programmation-manager/add-relation`

  const res = await post(url, { relation_type, task_from, task_to }, 'ADD_RELATION')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateRelation = async (relation_id: string, relation: any, task_id: string) => {
  const url = `${config.apiHost}/programmation-manager/update-relation`

  const res = await post(url, { relation_id, relation, task_id }, 'UPDATE_RELATION')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const deleteRelation = async (relation_id: string) => {
  const url = `${config.apiHost}/programmation-manager/delete-relation`

  const res = await post(url, { relation_id }, 'REMOVE_RELATION')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const addConstraint = async (task_id: string, constraint: any) => {
  const url = `${config.apiHost}/programmation-manager/add-constraint`

  const res = await post(url, { task_id, constraint }, 'ADD_CONSTRAINT')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const updateConstraint = async (task_id: string, constraint: any) => {
  const url = `${config.apiHost}/programmation-manager/update-constraint`

  const res = await post(url, { task_id, constraint }, 'UPDATE_CONSTRAINT')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const removeConstraint = async (task_id: string, constraint_id: string) => {
  const url = `${config.apiHost}/programmation-manager/delete-constraint`

  const res = await post(url, { task_id, constraint_id }, 'REMOVE_CONSTRAINT')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const addResponsible = async (task_id: string, responsible_id: string) => {

  const url = `${config.apiHost}/programmation-manager/add-responsible`

  const res = await post(url, { task_id, responsible_id }, 'ADD_RESPONSIBLE')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const removeResponsible = async (task_id: string, responsible_id: string) => {

  const url = `${config.apiHost}/programmation-manager/remove-responsible`

  const res = await post(url, { task_id, responsible_id }, 'REMOVE_RESPONSIBLE')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const addInternalProfile = async (task_id: string, profile_id: string) => {

  const url = `${config.apiHost}/programmation-manager/add-internal-profile`

  const res = await post(url, { task_id, profile_id }, 'ADD_INTERNAL_PROFILE')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const removeInternalProfile = async (task_id: string, profile_id: string) => {

  const url = `${config.apiHost}/programmation-manager/remove-internal-profile`

  const res = await post(url, { task_id, profile_id }, 'REMOVE_INTERNAL_PROFILE')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const downloadDocument = async (document_id: string) => {
  const url = `${config.apiHost}/programmation-manager/download-document`

  const headers = getHeaders()

  try {

    const res = await axios.post(url, { document_id }, {
      headers: {
        ...headers,
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    })

    return [null, res]
  } catch (error) {

    return [error, null]
  }

}

export const addDocument = async (task_id: string, file: any, name: string) => {

  const url = `${config.apiHost}/upload/document`

  const formData = new FormData();
  formData.append('file', file);
  formData.append('task_id', task_id)
  formData.append('name', name)

  try {

    const headers = getHeaders()

    const { data } = await axios.post(
      url,
      formData,
      {
        headers: {
          ...headers,
          'Content-Type': 'multipart/form-data'
        },
      }
    )

    if (!data.success) {

      throw new Error(data.error)
    }

    return [null, data]
  } catch (error) {

    return [error, null]
  }
}

export const updateDocument = async (document_id: string, name: any) => {

  const url = `${config.apiHost}/programmation-manager/update-document`

  const res = await post(url, { document_id, name }, 'UPDATE_DOCUMENT')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const deleteDocument = async (document_id: string) => {

  const url = `${config.apiHost}/programmation-manager/delete-document`

  const res = await post(url, { document_id }, 'DELETE_DOCUMENT')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const deleteTask = async (task_id: string) => {

  const url = `${config.apiHost}/programmation-manager/delete-task`

  const res = await post(url, { task_id }, 'DELETE_TASK')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}

export const deleteGroup = async (group_id: string, project_id: string) => {

  const url = `${config.apiHost}/programmation-manager/delete-group`

  const res = await post(url, { group_id, project_id }, 'DELETE_GROUP')

  if (res.error || !res.data.success) {

    return [res, null]
  }

  return [null, res.data]
}
